import { API } from "../APIs/index";
import { Pagination, Tokens } from "../Interfaces/Interfaces";
import { TokenValidator } from "./TokenValidator";

export default class AggregatorService {
  tokens: any | Tokens;
  get = API.aggregator + "get/";
  post = API.aggregator + "post/";
  put = API.aggregator + "put/";
  transfer = API.transfers + "post/";
  fundTransfer = API.fundsTransfer + "post/";

  constructor() {
    this.tokens = TokenValidator();
  }

  async getDashboard() {
    try {
      let response = await fetch(this.get + `aggregator/dashboard`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getUser(id: string) {
    try {
      let response = await fetch(this.get + `aggregator/findBy/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getCurrentUser() {
    try {
      let response = await fetch(this.get + `aggregator/getCurrentUser`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorDetails(id: string) {
    try {
      let response = await fetch(this.get + `aggregator/GetDetails/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getTradePartnerLocation() {
    try {
      let response = await fetch(
        this.get + `aggregator/TradePartnerLocations`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async inviteAggregatorService(data: any) {
    try {
      let response = await fetch(this.post + `Aggregator/InviteAggregator`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async onboardAgents(data: any) {
    try {
      let response = await fetch(this.post + `aggregator/onboard-agent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  // commission
  async getAggregatorCommission(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `AggregatorCommission/${data.id}/count/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  // getCashoutAccount
  async getCashoutAccount(id: string) {
    try {
      let response = await fetch(
        this.get + `aggregator/getCashoutAccount/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  // withdrawToWallet
  async withdrawToWallet(data: any) {
    try {
      let response = await fetch(
        this.transfer + `transfer/fromAggreggatorCommission`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  // withdrawToBank
  async withdrawToBank(data: any) {
    try {
      let response = await fetch(
        this.fundTransfer +
          `FundTransfer/AggregatorCommissionOtherBankWithdrawal`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  // withdrawFromCommissionToWallet
  async withdrawFromCommissionToWallet(data: any) {
    try {
      let response = await fetch(
        this.fundTransfer +
          `FundTransfer/AggregatorCommissionToMainWalletWithdrawal`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  // withdrawFromCommissionToWallet
  async withdrawalFromWalletToOtherBank(data: any) {
    try {
      let response = await fetch(
        this.fundTransfer +
          `FundTransfer/AggregatorWalletOtherBankWithdrawal`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async createPin(data: any) {
    try {
      let response = await fetch(this.post + "aggregator/createPin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async createAdminUserPin(data: any) {
    try {
      let response = await fetch(this.post + "aggregatoradmin/createPin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  //createAdminUserPin

  async createCahoutAccount(data: any) {
    // Aggregator/v2/createcashoutaccount
    try {
      let response = await fetch(
        this.post + "Aggregator/v2/createcashoutaccount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async changePin(data: any) {
    try {
      let response = await fetch(this.post + "aggregator/changePin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async onboardAggregators(data: any) {
    try {
      let response = await fetch(this.post + `aggregator`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregators(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `aggregator/getAggregators/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          // method: "POST",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorByPhone(phoneNumber: any) {
    try {
      let response = await fetch(
        this.get + `aggregator/findBy/${phoneNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorById(id: any) {
    try {
      let response = await fetch(this.get + `aggregator/find/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async queryAggregators(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `aggregator/queryAggregators/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async resetPin(data: any) {
    try {
      let response = await fetch(this.put + "aggregator/resetTransactionPin", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async acceptAggregatorInvite(data: any) {
    try {
      let response = await fetch(
        this.put + "aggregator/MapAggregatorToSuperAggregator",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async resetUserPersonnelPin(data: any) {
    try {
      let response = await fetch(
        this.put + "aggregatoradmin/resetTransactionPin",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
}
